import {
    primaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    transition,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    roseBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    roseCardHeader,
} from "assets/jss/material-dashboard-pro-react.jsx";

const customerProductStyle = {
    container: {
        ...transition,
        backgroundColor: '#ffffff',
        height: 150,
        cursor: 'pointer',
        marginTop: 0,
        zIndex: 2,
        "&:hover": {
            ...transition,
            backgroundColor: 'rgba(244,244,244,1)'
        },
        "&:active": {
            ...primaryBoxShadow
        }
    },
    content: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        width: 130,
        paddingRight: 20
    },
    label: {
        textAlign: 'left',
        flex: 1,
        fontSize: '1.3em'
    },
    count: {
        textAlign: 'right',
        fontSize: '1.5em',
        fontWeight: 'bold',
        color: 'rgba(0,0,0,0.3)',
    },
    caret: {
        ...transition,
        transform: 'rotate(0deg)',
        padding: "0 30px",
        color: 'rgba(0,0,0,0.3)',
        "&.open": {
            ...transition,
            transform: 'rotate(-90deg)'
        }
    },
    stats: {
        ...transition,
        height: 0,
        zIndex: 1,
        marginTop: -80,
        padding: 20,
        width: 'calc(100% - 40px)',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflow: 'hidden',
        
        "&.open": {
            ...transition,
            marginTop: -36,
            overflow: 'auto',
        },

        "&:hover": {
            ...primaryBoxShadow
        }
    }
};

export default customerProductStyle;